import { render, staticRenderFns } from "./details-header.vue?vue&type=template&id=927f8c88&scoped=true"
import script from "./details-header.vue?vue&type=script&lang=js"
export * from "./details-header.vue?vue&type=script&lang=js"
import style0 from "./details-header.vue?vue&type=style&index=0&id=927f8c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927f8c88",
  null
  
)

export default component.exports